import { useSnackbars } from '@customerio/pluma-components/react';
import { WORKSPACE_MISMATCH_SNACKBAR_KEY } from '@/features/account-switcher/constants';
import { useMountEffect } from '@/hooks/state/use-mount-effect';

type WorkspaceMismatchSnackbar = 'none' | 'no-permission' | 'masq-ended';

function getWorkspaceMismatchSnackbar(): WorkspaceMismatchSnackbar {
  try {
    const raw = sessionStorage.getItem(WORKSPACE_MISMATCH_SNACKBAR_KEY);
    if (raw == null) {
      return 'none';
    }
    return raw === 'masq' ? 'masq-ended' : 'no-permission';
  } finally {
    sessionStorage.removeItem(WORKSPACE_MISMATCH_SNACKBAR_KEY);
  }
}

/**
 * After a workspace mismatch redirect (no session has access to the workspace
 * in the URL), checks sessionStorage for a pending snackbar marker and displays
 * a "no permission" message — or, when the mismatch was an expired masquerade
 * (marker value `'masq'`), a message saying the masquerade ended.
 */
export function useWorkspaceMismatchSnackbar(): void {
  const snackbars = useSnackbars();

  useMountEffect(() => {
    const snackbar = getWorkspaceMismatchSnackbar();
    if (snackbar === 'none') {
      return;
    }

    snackbars.create({
      message:
        snackbar === 'masq-ended' ? 'Your masquerade session has ended' : "You don't have permission to view that page",
      variant: 'critical',
    });
  });
}
